import script from "./BaseDialogBox.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDialogBox.vue?vue&type=script&setup=true&lang=js"

import "./BaseDialogBox.vue?vue&type=style&index=0&id=1b2989c0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Veverica\\Documents\\projekti\\btc-prop\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b2989c0"]])

export default __exports__